import { render, staticRenderFns } from "./NiceClassTypeForm.vue?vue&type=template&id=24168f20&"
import script from "./NiceClassTypeForm.vue?vue&type=script&lang=js&"
export * from "./NiceClassTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./NiceClassTypeForm.vue?vue&type=style&index=0&id=24168f20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports